<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 21">
    <path
      d="M7.5,3.3v-1.5h5v1.5h-5ZM9.2,12.3h1.5v-5h-1.5v5ZM10,18.3c-1,0-1.9-.2-2.7-.6-.8-.4-1.6-.9-2.2-1.5-.6-.6-1.1-1.4-1.5-2.2-.4-.8-.6-1.8-.6-2.7s.2-1.9.6-2.7c.4-.8.9-1.6,1.5-2.2.6-.6,1.4-1.1,2.2-1.5.8-.4,1.8-.6,2.7-.6s1.6.1,2.3.4c.7.3,1.4.6,2.1,1.1l1.1-1.1,1,1-1.1,1.1c.5.6.9,1.3,1.1,2.1.3.7.4,1.5.4,2.3s-.2,1.9-.6,2.7c-.4.8-.9,1.6-1.5,2.2-.6.6-1.4,1.1-2.2,1.5-.8.4-1.8.6-2.7.6ZM10,16.8c1.5,0,2.8-.5,3.9-1.6s1.6-2.4,1.6-3.9-.5-2.8-1.6-3.9c-1.1-1.1-2.4-1.6-3.9-1.6s-2.8.5-3.9,1.6c-1.1,1.1-1.6,2.4-1.6,3.9s.5,2.8,1.6,3.9c1.1,1.1,2.4,1.6,3.9,1.6Z"
    />
  </svg>
</template>
